import React from 'react'
import Homepage from '../home-page.jpg'
import { Link } from 'react-router-dom'
const Somewhere = () => {
  return (
    <div>
        <div className='somewhere-home Home-cont'>
        <div className='left-home-somewhere' >
          <img src={Homepage} />
        </div>
        <div className='right-home-somewhere '>
        <h1>𝐖𝐄𝐋𝐂𝐎𝐌𝐄 𝐓𝐎 𝐯𝐓𝐀𝐋𝐊</h1>
        <h3>A chat application made using <span style={{color:"green"}}>react and firebase</span> </h3>
        <div className='d-flex' style={{gap:"20px"}}>
       <Link to='/login' className="btn btn-outline-primary " type="submit" style={{fontSize:"1.3rem"}}>Login</Link>
       <Link to='/signup' className="btn btn-outline-success " type="submit" style={{fontSize:"1.3rem"}}>Sign In</Link>
       </div>
       

        </div>  
        </div>
    </div>
  )
}

export default Somewhere